var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterPhone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone",
    clipPath: "url(#clip0_522_2687)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.568 10.0521L12.9697 12.6462C12.8856 13.013 12.5633 13.2695 12.1858 13.2695C5.69299 13.269 0.412109 7.98815 0.412109 1.49513C0.412109 1.11785 0.668665 0.795132 1.03542 0.711493L3.62954 0.113147C4.00733 0.0255955 4.39336 0.221698 4.55035 0.57947L5.74755 3.37175C5.8875 3.70065 5.7931 4.08385 5.51645 4.3098L4.13086 5.42234C5.00535 7.20374 6.45373 8.65212 8.23564 9.52712L9.37005 8.14256C9.59364 7.86513 9.97972 7.76914 10.3086 7.91158L13.1009 9.10853C13.4367 9.28521 13.6555 9.67638 13.568 10.0521Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_522_2687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.1765,
    height: 13.1765,
    fill: "white",
    transform: "translate(0.412109 0.0925293)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterPhone);
export default __webpack_public_path__ + "static/media/footerPhone.b81ee2ac6c1c7f8ae454475d64d4eebb.svg";
export { ForwardRef as ReactComponent };